import { render, staticRenderFns } from "./page-animation.vue?vue&type=template&id=1f6439f4&scoped=true"
import script from "./page-animation.vue?vue&type=script&lang=ts"
export * from "./page-animation.vue?vue&type=script&lang=ts"
import style0 from "./page-animation.vue?vue&type=style&index=0&id=1f6439f4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6439f4",
  null
  
)

export default component.exports